import { pascalToCamel, fleetoraRewriteProperties, toDayOfWeek, fleetoraAddProperties } from "../extensions";
import { fetchApi } from "./availability";
import { Vehicle, CachedSnapshot, Shift, Course, Trip, Model, Paint, PhotoMeta } from "../entities";

const baseUrl = "https://fleetora-service.akac.dev";

export default class FleetoraClient {
  apiKey?: string;

  constructor(apiKey?: string) {
    this.apiKey = apiKey;
  }

  async request(method: string, route: string, body: unknown = null) {
    let headers = new Headers();
    if (this.apiKey) headers.set("Authorization", this.apiKey);
    if (body) headers.set("Content-Type", "application/json; charset=utf-8");

    let path = `${baseUrl}/api/${route}`;
    let req = new Request(path, {
      method: method,
      body: body ? JSON.stringify(body) : null,
      headers: headers,
      credentials: this.apiKey ? "include" : "omit"
    });

    return await fetchApi(req);
  }

  async getTraffic() {
    let res = await this.request("GET", "provoz");
    if (!res.ok) throw `Failed to fetch cached traffic: ${res.status} => ${await res.text()}`;

    let data = fleetoraAddProperties(fleetoraRewriteProperties(pascalToCamel(await res.json()))) as Vehicle[];

    let snapshot: CachedSnapshot = {
      age: Number(res.headers.get("Age")),
      date: new Date(res.headers.get("Date")),
      dayOfWeek: toDayOfWeek(res.headers.get("Day-Of-Week")),
      isOld: false,
      vehicles: data
    };

    return snapshot;
  }

  async getTrip(tripId: number) {
    let res = await this.request("POST", `gtfs/trip`, tripId);
    if (!res.ok) throw `Failed to fetch trip ${tripId}: ${res.status} => ${await res.text()}`;

    return pascalToCamel(await res.json()) as Trip;
  }

  async getCourse(vehicleId: string) {
    let res = await this.request("POST", `provoz/course`, vehicleId);
    if (!res.ok) throw `Failed to fetch order of ${vehicleId}: ${res.status} => ${await res.text()}`;

    return pascalToCamel(await res.json()) as Course;
  }

  async getShift(vehicleId: string) {
    let res = await this.request("POST", `provoz/shift`, vehicleId);
    if (!res.ok) throw `Failed to fetch order of ${vehicleId}: ${res.status} => ${await res.text()}`;

    return pascalToCamel(await res.json()) as Shift;
  }

  async getPhotoMeta(documentationId: string) {
    let res = await this.request("POST", "image/meta", documentationId);
    if (!res.ok) throw `Failed to fetch photo meta for ${documentationId}: ${res.status} => ${await res.text()}`;

    return (await res.json()) as PhotoMeta;
  }

  async getCarrier() {
    let res = await this.request("GET", "seznam-autobusu/carrier");
    if (!res.ok) throw `Failed to fetch carrier: ${res.status} => ${await res.text()}`;

    return (await res.json()) as Model[];
  }

  async getPaints() {
    let res = await this.request("GET", "seznam-autobusu/paint-vehicles");
    if (!res.ok) throw `Failed to fetch paints: ${res.status} => ${await res.text()}`;

    return (await res.json()) as Paint[];
  }
}
